import * as actionsImport from './actions/index';
import * as reducersImport from './reducers/index';
import * as selectorsImport from './selectors/index';
import * as typesImport from './cookie-policy.types';

export const actions = actionsImport;
export const reducers = reducersImport;
export const selectors = selectorsImport;
export const types = typesImport;
